import { ContentfulProduct } from '@web/common';
import { getProductData } from './getProductData';
import { Flex, Text } from '@mantine/core';
import plant from '../../../../../assets/weed_plant.svg';

export const ProductItem = ({ data }: { data: ContentfulProduct }) => {
  const {
    title,
    thcLevel,
    thcPercentage,
    cbdPercentage,
    producer,
    strainDominance,
    image,
    amountPerUnit,
  } = getProductData(data);
  return (
    <Flex
      direction="column"
      w="250px"
      h="100%"
      ta="start"
      gap=" 16px"
      p="20px"
      bg="rgba(241, 240, 232, 0.6)"
      style={{ borderRadius: '4px' }}
    >
      {image && (
        <img
          src={image}
          alt={title}
          width={210}
          style={{ borderRadius: '4px' }}
        />
      )}
      <Flex justify="space-between" w="100%">
        <Flex gap="4px" h="24px">
          {Array.from({ length: thcLevel }, (_, index) => (
            <img key={index} src={plant} alt="THC level indicator" />
          ))}
        </Flex>
      </Flex>

      <Text size="16px" lh="24px" fw="700">
        {title}
      </Text>

      <Flex direction="column" gap="8px">
        {amountPerUnit && (
          <Text size="16px" fw="400" lh="24px">
            {amountPerUnit}
          </Text>
        )}
        {thcPercentage && cbdPercentage && (
          <Text size="16px" fw="400" lh="24px">
            THC {thcPercentage} % / CBD {cbdPercentage} %
          </Text>
        )}
        {strainDominance && (
          <Text size="16px" fw="400" lh="24px">
            {strainDominance}
          </Text>
        )}
        <Text size="16px" fw="400" lh="24px">
          {producer}
        </Text>
      </Flex>
    </Flex>
  );
};
